import {
  addBookingGuest,
  getBookingByGuestUuid,
} from "../../Redux/Bookings/BookingsActions";
import Loading from "../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import styles from "./GuestInvite.module.scss";
import validator from "../../Util/validator";
import Error404 from "../Error404/Error404";
import Logo from "../../Assets/Logo.png";
import { useParams } from "react-router";
import moment from "moment";

function GuestInvite() {
  const { uuid } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const {
    addBookingGuestLoading,
    addBookingGuestData,
    bookingByGuestUuidData,
    bookingByGuestUuidLoading,
    bookingByGuestUuidError,
  } = useSelector((state: RootState) => state.bookings);
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [errors, setErrors] = useState<{
    firstName: string;
    lastName: string;
    email: string;
  }>({
    firstName: "",
    lastName: "",
    email: "",
  });

  const submitHandler = (e: React.FormEvent) => {
    e.preventDefault();
    const { errors: fieldErrors, isValid } = validator([
      {
        key: "firstName",
        type: "text",
        value: firstName,
      },
      {
        key: "lastName",
        type: "text",
        value: lastName,
      },
      {
        key: "email",
        type: "email",
        value: email,
      },
    ]);
    setErrors({ ...errors, ...fieldErrors });
    if (isValid && !addBookingGuestLoading) {
      const successHandler = () => {
        setFirstName("");
        setLastName("");
        setEmail("");
        setPhoneNumber("");
        setErrors({
          firstName: "",
          lastName: "",
          email: "",
        });
      };

      dispatch(
        addBookingGuest({
          bookingUUid: uuid || "",
          firstName,
          lastName,
          email,
          phoneNumber,
          successHandler,
        }),
      );
    }
  };

  useEffect(() => {
    if (uuid) {
      dispatch(
        getBookingByGuestUuid({
          bookingUuid: uuid,
        }),
      );
    }
  }, [uuid, dispatch]);

  return (
    <React.Fragment>
      {(bookingByGuestUuidLoading || addBookingGuestLoading) && <Loading />}
      {bookingByGuestUuidError && <Error404 />}
      {bookingByGuestUuidData && (
        <div className={styles.mainContainer}>
          <div className={styles.headerContainer}>
            <div className={styles.logoContainer}>
              <img src={Logo} alt="logo" className={styles.logo} />
            </div>
          </div>
          <div className={styles.bodyMainContainer}>
            <div className={styles.headingContainer}>
              <p className={styles.heading}>Guest Invite</p>
            </div>
            <div className={styles.bodyContainer}>
              <div className={styles.infoContainer}>
                <p className={styles.text}>
                  Please enter your information to get access as a guest
                </p>
              </div>
              <div className={styles.formContainer}>
                <form>
                  <div className={styles.inputContainer}>
                    <p className={styles.label}>First Name</p>
                    <input
                      type="text"
                      className={styles.input}
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                    <p className={styles.error}>{errors.firstName}</p>
                  </div>
                  <div className={styles.inputContainer}>
                    <p className={styles.label}>Last Name</p>
                    <input
                      type="text"
                      className={styles.input}
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                    <p className={styles.error}>{errors.lastName}</p>
                  </div>
                  <div className={styles.inputContainer}>
                    <p className={styles.label}>Email</p>
                    <input
                      type="email"
                      className={styles.input}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <p className={styles.error}>{errors.email}</p>
                  </div>
                  <div className={styles.inputContainer}>
                    <p className={styles.label}>Phone Number (Optional)</p>
                    <input
                      type="text"
                      className={styles.input}
                      value={phoneNumber}
                      onChange={(e) => {
                        if (/^\d*$/.test(e.target.value)) {
                          setPhoneNumber(e.target.value);
                        }
                      }}
                    />
                  </div>
                  <div className={styles.buttonContainer}>
                    <button
                      type="submit"
                      className={styles.button}
                      onClick={submitHandler}
                    >
                      Submit
                    </button>
                  </div>
                </form>
                <div className={styles.informationContainer}>
                  <div className={styles.summaryContainer}>
                    <div className={styles.summaryHeader}>
                      <h2 className={styles.heading}>Event Information</h2>
                    </div>
                    <div className={styles.summaryBody}>
                      <div className={styles.summaryItem}>
                        <p className={styles.label}>Event Name</p>
                        <p className={styles.value}>
                          {bookingByGuestUuidData?.amenityName}
                        </p>
                      </div>
                      <div className={styles.summaryItem}>
                        <p className={styles.label}>Date</p>
                        <p className={styles.value}>
                          {moment(bookingByGuestUuidData?.startTime).format(
                            "DD/MM/YYYY",
                          )}
                        </p>
                      </div>
                      {bookingByGuestUuidData?.rateType === "Per Hour" && (
                        <div className={styles.summaryItem}>
                          <p className={styles.label}>Time</p>
                          <p className={styles.value}>
                            {moment(bookingByGuestUuidData?.startTime).format(
                              "hh:mm A",
                            )}{" "}
                            -{" "}
                            {moment(bookingByGuestUuidData?.endTime).format(
                              "hh:mm A",
                            )}
                          </p>
                        </div>
                      )}
                      {/* <div className={styles.summaryItem}>
                        <p className={styles.label}>Location</p>
                        <p className={styles.value}>
                          123 Main St, Anytown, USA
                        </p>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
              {addBookingGuestData && (
                <div className={styles.successContainer}>
                  <p className={styles.text}>Guest added successfully</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default GuestInvite;
